import { forwardRef, useState } from 'react'
import { Icon } from '@iconify/react'

const Input = forwardRef(
  ({ label, error, helperText, icon, className = '', type, showPasswordToggle, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false)
    const isPassword = type === 'password'
    const inputType = isPassword && showPasswordToggle ? (showPassword ? 'text' : 'password') : type

    return (
      <div className="mb-4">
        {label && (
          <label className="form-label">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary z-10">
              <span className="text-lg">{icon}</span>
            </div>
          )}
          <input
            ref={ref}
            type={inputType}
            className={`form-control ${icon ? 'pl-10' : ''} ${isPassword && showPasswordToggle ? 'pr-10' : ''} ${error ? 'border-danger focus:border-danger focus:ring-danger/10' : ''} ${className}`}
            {...props}
          />
          {isPassword && showPasswordToggle && (
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-text-secondary hover:text-primary transition-colors z-10"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              <Icon
                icon={showPassword ? 'mdi:eye-off' : 'mdi:eye'}
                className="text-xl"
              />
            </button>
          )}
        </div>
        {error && (
          <p className="mt-1 text-sm text-danger">{error}</p>
        )}
        {helperText && !error && (
          <p className="mt-1 text-sm text-text-secondary">{helperText}</p>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'

export default Input
